import { Injectable, Injector, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from "@angular/common";

import { FirebaseService } from "../firebase/firebase.service";

let $_: any;

export interface IApiClient {

    id?: string;
    parent_agency_id: string;
    agency_id: string;
    name: string;
    disabled: boolean;
    active: boolean;
}

export class ApiClient implements IApiClient {

    id?: string;
    parent_agency_id: string;
    agency_id: string;
    name: string;
    disabled: boolean;
    active: boolean;
    child_agencies: number;

    constructor(api_client: IApiClient) {

        this.id = api_client.id;
        this.parent_agency_id = api_client.parent_agency_id;
        this.agency_id = api_client.agency_id;
        this.name = api_client.name;
        this.disabled = api_client.disabled;
        this.child_agencies = 0;
        this.active = api_client.active;
    }
}

@Injectable()
export class ApiClientsService {

    db_read_complete: boolean = false;
    private api_clients: IApiClient[] = [];

    constructor(private injector: Injector, @Inject(PLATFORM_ID) private platformId: Object, private fb: FirebaseService) {

        $_ = this;
    }

    private sort_api_clients() {

        if ($_.db_read_complete) {

            for (var i = 0; i < $_.api_clients.length; i++) {

                $_.api_clients[i].child_agencies = 0;

                for (var j = 0; j < $_.api_clients.length; j++) {

                    if ($_.api_clients[i].agency_id === $_.api_clients[j].parent_agency_id) {

                        $_.api_clients[i].child_agencies++;
                    }
                }
            }

            $_.api_clients.sort((api_clienta: ApiClient, api_clientb: ApiClient) => {

                var result = 0;

                // sort parent agencies to top
                if (api_clienta.parent_agency_id === api_clienta.agency_id &&
                    api_clientb.parent_agency_id !== api_clientb.agency_id) {

                    result = -1;
                }
                else if (api_clienta.parent_agency_id !== api_clienta.agency_id &&
                    api_clientb.parent_agency_id === api_clientb.agency_id) {

                    result = 1;
                }
                else {

                    // sort agencies then by name
                    result = api_clienta.name.toLowerCase() > api_clientb.name.toLowerCase() ? 1 : -1;
                }

                return result;
            })
        }

        return $_.api_clients;
    }

    public get_api_clients(parent_agency_id: string, complete: (api_clients: IApiClient[]) => void) {

        $_.api_clients = [];
        $_.db_read_complete = false;

        if (isPlatformBrowser($_.platformId)) {

            if ($_.unsubscribe) {

                $_.unsubscribe();
            }

            $_.query = $_.fb.db.collection("api_clients");

            if (parent_agency_id !== '') {

                $_.query = $_.query.where('parent_agency_id', '==', parent_agency_id);
            }

            $_.unsubscribe = $_.query.onSnapshot((querySnapshot: any) => {

                const creates: any[] = querySnapshot.docChanges.filter(api_client => api_client.type === "added");
                const updates: any[] = querySnapshot.docChanges.filter(api_client => api_client.type === "modified");
                const deletes: any[] = querySnapshot.docChanges.filter(api_client => api_client.type === "removed");

                creates.forEach(api_client => $_.create_api_client(api_client));
                updates.forEach(api_client => $_.update_api_client(api_client));
                deletes.forEach(api_client => $_.delete_api_client(api_client));

                $_.db_read_complete = true;

                complete($_.sort_api_clients());

            }, error => console.log("Error getting api_clients: ", error));
        }
        else {

            var api_clients = null;

            try {

                if ($_.injector) {

                    api_clients = $_.injector.get("api_clients");
                }                

            } catch (err) {

                console.log('get_api_clients injector error');
            }

            if (api_clients) {

                $_.api_clients = api_clients;
            }

            $_.db_read_complete = true;
            complete($_.sort_api_clients());
        }
    }

    private create_api_client(doc: any) {

        if (doc.doc.data().active === false) {

            $_.delete_api_client(doc);
        }
        else {

            const api_client: IApiClient = doc.doc.data();

            api_client.id = doc.doc.id;

            $_.api_clients.push(new ApiClient(api_client));

            $_.sort_api_clients();
        }
    }

    private update_api_client(doc: any) {

        if (doc.doc.data().active === false) {

            $_.delete_api_client(doc);
        }
        else {

            var index = $_.api_clients.findIndex(api_client => api_client.id === doc.doc.id);

            if (index > -1) {

                $_.api_clients[index] = Object.assign($_.api_clients[index], doc.doc.data());
            }

            $_.sort_api_clients();
        }
    }

    private delete_api_client(doc: any) {

        var index = $_.api_clients.findIndex(api_client => api_client.id === doc.doc.id);

        if (index > -1) {

            $_.api_clients.splice(index, 1);

            $_.sort_api_clients();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/api-clients/api-clients.service.ts